import React from "react";
import { inject, observer } from "mobx-react";
import { LightButton, PrimaryButton, StickyFooterButtons } from "best-common-react";

class TicketEventsFooter extends React.Component {
  render() {
    const { requestSidebarStore, authStore } = this.props.rootStore;

    return (
      <StickyFooterButtons
        startsOpen={authStore.userData && authStore.userData.org && authStore.userData.org.orgId === 31}
      >
        <PrimaryButton
          id="requestGames"
          onClick={() => requestSidebarStore.createRequests()}
          disabled={requestSidebarStore.selectedGames.length === 0}
        >
          Create Requests
        </PrimaryButton>
      </StickyFooterButtons>
    );
  }
}

export default inject("rootStore")(observer(TicketEventsFooter));
